<template>
  <div class="home">
    <div class="home-wrapper">
      <div class="home-left">
        <div class="filter-wrapper">
          <div>
            <div class="date-range-picker">
              <DatePicker
                ref="dateRangePicker"
                v-model="dateRange"
                range
                type="daterange"
                format="DD MMM YYYY"
                placeholder="Start Date - End Date"
                :disabled="dataSelectLastDayValue.key !== 'custom'"
                popper-class="green-theme"
                range-separator=" — "
                :lang="{
                  formatLocale: {
                    firstDayOfWeek: 1,
                  }
                }"
                input-class="custom-input"
                :confirm="true"
                confirm-text="OK"
                @change="changeDateRange"
                @clear="resetToDefault">
                <template #icon-calendar>
                  <font-awesome-icon :icon="dataCalendarDays" />
                </template>
              </DatePicker>
            </div>
            <v-select
              v-if="computedIsAdmin"
              v-model="dataSelectTeamsValue"
              :options="dataSelectOptionsTeam"
              label="name"
              :components="{ Deselect: dataComponentDeselect }"
              placeholder="All Teams"
              :class="[
                'call-select teams-filter',
                dataSelectTeamsValue ? 'call-select--value' : null
              ]"
              @input="$_ajax({ reset: true })">
              <template #open-indicator="{ attributes }">
                <span v-bind="attributes">
                  <font-awesome-icon :icon="dataIconDown" />
                </span>
              </template>
              <template
                slot="option"
                slot-scope="option">
                <div class="d-center">
                  <font-awesome-icon
                    v-if="!option.is_active"
                    class="tabel-icon--red"
                    style="font-size: 10px;"
                    :icon="dataIconLock" />
                  {{ option.name }}
                </div>
              </template>
            </v-select>
          </div>
          <div />
        </div>
        <div class="bl-wr">
          <div class="table-wrapper">
            <b-table
              :show-empty="isLoaded"
              hover
              no-local-sorting
              table-class="deposits-table"
              :fields="dataMixinDepositsFields"
              :items="dataTeamsList"
              tbody-tr-class="row-white"
              @row-hovered="onHover"
              @row-unhovered="onUnHover">
              <template #empty>
                <EmptyTable />
              </template>
              <template #cell(actions)="data">
                <call-table-deposits-actions
                  v-show="data.item.actions || data.item._showDetails"
                  :block="!data.item.is_active"
                  :rotate="data.item._showDetails"
                  @on-action="value => onActions(data, value)" />
              </template>
              <template #row-details="row">
                <b-table
                  :show-empty="isLoaded"
                  hover
                  no-local-sorting
                  table-class="deposits-subtable"
                  :fields="dataMixinDepositsProjectFields"
                  :items="
                    row.item.projects.map(item => {
                      item.actions = '';
                      return item;
                    })
                  "
                  tbody-tr-class="row-blue"
                  @row-hovered="onHover"
                  @row-unhovered="onUnHover" />
              </template>
            </b-table>
          </div>

          <div class="home-right">
            <BarChart
              v-if="totalAmountByDate.length"
              :formatted-range="formattedRange"
              :total-amount-by-date="totalAmountByDate"
              :data-select-chart-value-id="dataSelectChartValueId"
              @dataSelectChartValue="
                value => {
                  dataSelectChartValueId = value.id;
                  $_ajax({ reset: true });
                }
              " />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { BTable } from 'bootstrap-vue';
import {
  faCheck,
  faPlus,
  faPowerOff,
  faSearch
} from '@fortawesome/pro-regular-svg-icons';
import { faCalendarDays } from '@fortawesome/pro-light-svg-icons';
import { mapGetters } from 'vuex';
import {
  TEAMS_GET_ALL,
  DEPOSITS_GET_ALL
} from '../../../store/types/actions.types';
import depositsTable from '../../../mixins/table/depositsTable';
import depositsProjectSubTable from '../../../mixins/table/depositsProjectSubTable';
import selectTeamLeader from '../../../mixins/select/selectTeamLeader';
import selectDepositsPeriod from '../../../mixins/select/selectDepositsPeriod';
import helper from '../../../service/helper';
import selectAllTeams from '../../../mixins/select/selectAllTeams';
import CallTableDepositsActions from '../../../components/desktop/CallTableDepositsActions';
import BarChart from './BarChart.vue';
import moment from 'moment';

const defaultDate = [
  moment().startOf('month').format('YYYY-MM-DD HH:mm:ss'),
  // moment()
  //   .year(2024)
  //   .startOf('year')
  //   .format('YYYY-MM-DD HH:mm:ss'),
  moment()
    .endOf('month')
    .format('YYYY-MM-DD HH:mm:ss')
];

export default {
  name: 'PageTeams',
  components: {
    CallTableDepositsActions,
    BarChart,
    BTable
  },
  mixins: [
    depositsTable,
    selectTeamLeader,
    depositsProjectSubTable,
    selectAllTeams,
    selectDepositsPeriod
  ],
  data () {
    return {
      isLoaded: false,
      dataAddIcon: faPlus,
      dataCalendarDays: faCalendarDays,
      dataIconSearch: faSearch,
      dataIconCheck: faCheck,
      dataIconLock: faPowerOff,
      dataShowAddTeam: false,
      dataShowUpdateTeam: false,
      dataShowUpdateTeamId: null,
      dataTeamsList: [],
      dataSearch: null,
      dataDesc: null,
      dataOrderBy: null,
      dataObjPagination: {},
      //
      startDate: null,
      endDate: null,
      //
      defaultDateRange: [new Date(defaultDate[0]), new Date(defaultDate[1])],
      dateRange: [new Date(defaultDate[0]), new Date(defaultDate[1])],
      formattedRange: [defaultDate[0], defaultDate[1]],
      totalAmountByDate: [],
      dataSelectChartValueId: 'day',
      dataSelectOptionsTeam: []
    };
  },
  computed: {
    ...mapGetters({
      computedIsAdmin: 'auth/isAdmin'
    })
  },
  watch: {
    dataSelectTeamLeaderValue () {
      this.$_ajax({ reset: true });
    }
  },
  async created () {
    this.$_ajax = ((options = {}) => {
      const { currentRoute: { name: pageName } = {} } = this.$router;

      const _filterKey = `_filter${pageName}`;

      if (!helper.isEmpty(this.$route.query, _filterKey)) {
        try {
          options = helper.clearObject(
            JSON.parse(this.$route.query[_filterKey])
          );

          const _arrFilter = [
            'teamId',
            'period'
          ];

          for (const _key of _arrFilter) {
            if (!helper.isEmpty(options, _key)) {
              switch (_key) {
                case 'teamId':
                  this.dataSelectTeamLeaderValue = options[_key];
                  break;
                case 'period':
                  this.dataSelectLastDayValue = options[_key];
                  break;
              }
            }
          }
        } catch (e) {
          console.log('Error query params');
        }
      }

      return async ({
        teamId = this.dataSelectTeamsValue,
        dateRange = this.formattedRange
      } = {}) => {
        this.$store.dispatch('loading/startLoading');

        try {
          if (!this.dataSelectLastDayValue) {
            this.dataSelectLastDayValue = {
              ...this.dataSelectLastDayValueDefault
            };
          }

          const {
            payload: { report, total_amount_by_date }
          } = await this.$store.dispatch(`deposits/${DEPOSITS_GET_ALL}`, {
            params: {
              start_timestamp: dateRange[0],
              end_timestamp: dateRange[1],
              timezone: 0,
              team_ids: [teamId?.id],
              total_deposits_amount_group_by: this.dataSelectChartValueId
            }
          });

          this.totalAmountByDate = total_amount_by_date;
          this.dataTeamsList = report.map(item => {
            item.actions = false;
            item._showDetails = false;
            return item;
          });

          this.$router
            .replace({
              ...this.$router.currentRoute,
              query: {
                [_filterKey]: JSON.stringify(
                  helper.clearObject({
                    teamId,
                    period:
                      this.dataSelectLastDayValue?.key === -1
                        ? null
                        : this.dataSelectLastDayValue
                  })
                )
              }
            })
            .catch(() => {});

          options = {};
        } finally {
          this.$store.dispatch('loading/stopLoading');
        }
      };
    })();

    this.$_ajax();

    this.$store.dispatch('loading/startLoading');

    try {
      const [
        {
          payload: { list: listTeam = [] }
        }
      ] = await Promise.all([
        this.$store.dispatch(`team/${TEAMS_GET_ALL}`, {
          params: {
            short: true
          }
        }),
        this.$_ajax()
      ]);

      this.dataSelectOptionsTeam = listTeam.sort(
        (a, b) => b.is_active - a.is_active
      );
      this.isLoaded = true;
    } finally {
      this.$store.dispatch('loading/stopLoading');
    }
  },
  methods: {
    resetToDefault () {
      this.dateRange = [...this.defaultDateRange];
    },
    changeDateRange () {
      if (this.$refs.dateRangePicker) {
        this.$refs.dateRangePicker.closePopup();
      }
      setTimeout(() => {
        if (this.dateRange.length === 2) {
          this.formattedRange = [
            moment(this.dateRange[0]).format('YYYY-MM-DD HH:mm:ss'),
            moment(this.dateRange[1])
              .endOf('day')
              .format('YYYY-MM-DD HH:mm:ss')
          ];
          this.$_ajax();
        }
      }, 10);
    },

    async onActions (row, action) {
      row.toggleDetails();
    }
  }
};
</script>

<style lang="scss" scoped>
.home-wrapper {
  display: flex;
  gap: 32px;
  > .home-left {
    width: 100%;
    // width: 50%;
    gap: 16px;
  }
  .bl-wr {
    display: flex;
    gap: 32px;
    > div {
      width: 50%;
    }
  }
}
</style>

<style lang="scss">
.deposits-table {
  .row-blue {
    background-color: #f9f9f9;
  }

  .row-white {
    background-color: #fff;
  }
  .deposits-subtable {
    thead {
      height: 1px;

      * {
        padding: 0;
      }
      // display: none;
    }
  }
}
.home-left {
  .mx-input-wrapper {
    .custom-input {
      width: 100%;
    }
  }
  .date-range-picker {
    max-width: 220px;
    display: flex;
    align-items: center;
    background: #eeeeef;
    padding-left: 8px;
    border-radius: 8px;
    margin-right: 8px;
  }

  .custom-input {
    border: none;
    background: transparent;
    font-size: 14px;
    width: 100%;
  }
}
</style>
